import axios from 'axios';

export const getPosts = async () => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/post/`;
    try {
        const response = await axios.get(apiUrl);
        console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching practices:', error);
        throw error;
    }
};

export const getPostById = async (id) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/post/${id}`;
    try {
        const response = await axios.get(apiUrl);
        return response.data;
    } catch (error) {
        console.error('Error fetching practices:', error);
        throw error;
    }
};